<nav class="navbar navbar-expand-lg" style="background-color:#04042B ;">
  <div class="container-fluid" >
   <a class="navbar-brand logo text-3xl font-bold	ml-8 cursor-pointer" (click)="onHome()">Moving Picture Club</a>
    <div class="collapse navbar-collapse" id="navbarNav">
    </div>
  </div>
</nav>
